module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_LV-e5ccc3f87fe5eceb29733ed77f8064b5.svg";